module.exports = __webpack_public_path__ + "img/plan-service-icon1.7842ce22.png";